<template>
  <div class="screen-message-bubble">
    <ScreenMessageTextTarget
      v-if="isVisibleTarget"
      :content-target="chatMessageScreen.tgt.contents"
      :is-interpreting="isInterpretingTgt"
      :language-code-set="chatMessageScreen.tgtLanguageSet"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import ScreenMessageTextTarget from '@/components/domains/chat/chat-screen/ScreenMessageTextTarget.vue';
import { ChatMessage } from '@/types/socket';

const { chatMessageScreen } = defineProps<{
  chatMessageScreen: ChatMessage;
  isVisibleSource: boolean;
  isVisibleTarget: boolean;
}>();

const isPendingSrc = computed(() => {
  return (
    chatMessageScreen.reset === '0' &&
    (!chatMessageScreen.src.contents ||
      chatMessageScreen.src.contents?.length === 0)
  );
});

const isInterpretingTgt = computed(() => {
  return (
    chatMessageScreen.reset === '0' &&
    (!chatMessageScreen.tgt.contents ||
      chatMessageScreen.tgt.contents?.length === 0)
  );
});
</script>

<style scoped>
.line {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid var(--color-gray-600);
}
</style>
